import React, {Fragment} from "react";
import {Loading} from "store-fetch-wrappers";
import AssignUser from "./AssignUser";
import ReserveUser from "./ReserveUser";
import {
    AcceptRegisterRequestProps,
    useAcceptRegisterRequest
} from "./hooks/useAcceptRegisterRequest";
import MCButton, {ButtonColourOptions, ButtonSize} from "../../../../Button/MCButton";
import {showSuccessToast} from "../../../../../utils/toastUtils";

function AcceptRegisterRequest(props: AcceptRegisterRequestProps) {
    const {
        canBeAssigned,
        acceptUserInterest,
        loading,
        onReserveConfirmed,
        deleteExistingUserInterest
    } = useAcceptRegisterRequest(props);

    async function deleteInterest() {
        await deleteExistingUserInterest(props);
        showSuccessToast("User interest deleted");
    }

    return (
        <Fragment>
            {loading ? (
                <Loading type={"three-ring"} showLoadingText={false} />
            ) : (
                <Fragment>
                    {canBeAssigned ? (
                        <div className="interest-btns">
                            <AssignUser
                                action={props}
                                onRateConfirmed={async (newRate) => {
                                    await acceptUserInterest(newRate, props);
                                    if (props.hideElement) props.hideElement();
                                }}
                                defaultRate={props.defaultRate ?? 0}
                            />
                            <MCButton
                                size={ButtonSize.Large}
                                innerValue={"Delete"}
                                onClick={deleteInterest}
                                colour={ButtonColourOptions.Orange}
                                roundedCorner
                            />
                        </div>
                    ) : (
                        <div className="interest-btns">
                            {props.interest.reserveNotification ? (
                                <p className="mb-0">
                                    Staff Member has been added to the reserve list.
                                </p>
                            ) : (
                                <ReserveUser
                                    onConfirm={() =>
                                        onReserveConfirmed({
                                            entry: props.entry,
                                            interest: props.interest
                                        })
                                    }
                                />
                            )}
                            <MCButton
                                size={ButtonSize.Large}
                                innerValue={"Delete"}
                                onClick={deleteInterest}
                                colour={ButtonColourOptions.Orange}
                                roundedCorner
                            />
                        </div>
                    )}
                </Fragment>
            )}
        </Fragment>
    );
}

export default AcceptRegisterRequest;
